import { render, staticRenderFns } from "./ScreeningProcessSummary.vue?vue&type=template&id=7b9ade52&scoped=true&"
import script from "./ScreeningProcessSummary.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcessSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9ade52",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VAvatar,VCard,VCardText,VChip,VCol,VDivider,VIcon,VList,VListItem,VRow,VSubheader})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b9ade52')) {
      api.createRecord('7b9ade52', component.options)
    } else {
      api.reload('7b9ade52', component.options)
    }
    module.hot.accept("./ScreeningProcessSummary.vue?vue&type=template&id=7b9ade52&scoped=true&", function () {
      api.rerender('7b9ade52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/ScreeningProcessSummary.vue"
export default component.exports